import {
    FORUM_SEARCH_UPDATE,
    ForumSearchUpdateAction,
} from 'mk2/apps/forum/containers/ForumSearch/ForumSearch.actions';
import { initialForumSearchState } from 'mk2/apps/forum/containers/ForumSearch/ForumSearch.constants';
import { tupdate } from 'mk2/helpers/types';
import { Reducer } from 'redux';

export interface ForumSearchState {
    query: string;
}

const forumSearchReducer: Reducer<ForumSearchState> = (state: ForumSearchState = initialForumSearchState, action: ForumSearchUpdateAction) => {
    switch (action.type) {
        case FORUM_SEARCH_UPDATE:
            return tupdate(state, {
                query: action.query,
            });
        default:
            return state;
    }
};

export default forumSearchReducer;
